module.exports = __webpack_public_path__ + "img/api-image.8399c975.png";